import { AxiosResponse } from "axios";
import { AuthenticatedClient, RoleResponseType } from "_api";

export const getRoles = (): Promise<AxiosResponse<RoleResponseType[]>> => {
  return AuthenticatedClient.get('/roles');
};